import { render, staticRenderFns } from "./PaymentsTerm.vue?vue&type=template&id=06dce9e2"
import script from "./PaymentsTerm.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsTerm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports